import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Sparkles,
  Layers,
  Zap,
  Heart,
  Target,
  Eye,
  Shield,
  ArrowRight,
  Gift,
} from "lucide-react";
import { PublicNavbar, PublicFooter } from "./PublicLayout";
import "./LandingPage.css";
import "./StaticPages.css";

function AboutUs() {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cards = [
    {
      icon: Sparkles,
      title: t("about.card1Title"),
      desc: t("about.card1Desc"),
      bg: "rgba(139, 92, 246, 0.08)",
      color: "#8b5cf6",
    },
    {
      icon: Layers,
      title: t("about.card2Title"),
      desc: t("about.card2Desc"),
      bg: "rgba(59, 130, 246, 0.08)",
      color: "#3b82f6",
    },
    {
      icon: Zap,
      title: t("about.card3Title"),
      desc: t("about.card3Desc"),
      bg: "rgba(245, 158, 11, 0.08)",
      color: "#f59e0b",
    },
  ];

  const values = [
    {
      icon: Heart,
      title: t("about.val1Title"),
      desc: t("about.val1Desc"),
      bg: "rgba(239, 68, 68, 0.1)",
      color: "#ef4444",
    },
    {
      icon: Target,
      title: t("about.val2Title"),
      desc: t("about.val2Desc"),
      bg: "rgba(102, 126, 234, 0.1)",
      color: "#667eea",
    },
    {
      icon: Eye,
      title: t("about.val3Title"),
      desc: t("about.val3Desc"),
      bg: "rgba(16, 185, 129, 0.1)",
      color: "#10b981",
    },
    {
      icon: Shield,
      title: t("about.val4Title"),
      desc: t("about.val4Desc"),
      bg: "rgba(245, 158, 11, 0.1)",
      color: "#f59e0b",
    },
  ];

  return (
    <div className="landing-page">
      <PublicNavbar />

      <section className="sp-hero">
        <div className="sp-hero-pattern" />
        <div className="sp-hero-content">
          <h1>{t("about.heroTitle")}</h1>
          <p>{t("about.heroDesc")}</p>
        </div>
      </section>

      <div className="sp-content">
        {/* Mission */}
        <div className="sp-mission">
          <div className="sp-mission-tag">{t("about.missionTag")}</div>
          <h2>{t("about.missionTitle")}</h2>
          <p>{t("about.missionDesc")}</p>
        </div>

        {/* What We Do - Cards */}
        <div className="sp-cards">
          {cards.map((card, i) => (
            <div className="sp-card" key={i}>
              <div className="sp-card-icon" style={{ background: card.bg, color: card.color }}>
                <card.icon size={22} />
              </div>
              <h3>{card.title}</h3>
              <p>{card.desc}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="sp-stats">
          <div className="sp-stat">
            <div className="sp-stat-value">21+</div>
            <div className="sp-stat-label">{t("about.statFormats")}</div>
          </div>
          <div className="sp-stat">
            <div className="sp-stat-value">17</div>
            <div className="sp-stat-label">{t("about.statBrands")}</div>
          </div>
          <div className="sp-stat">
            <div className="sp-stat-value">2</div>
            <div className="sp-stat-label">{t("about.statLanguages")}</div>
          </div>
          <div className="sp-stat">
            <div className="sp-stat-value">24/7</div>
            <div className="sp-stat-label">{t("about.statAvailability")}</div>
          </div>
        </div>

        {/* Values */}
        <div className="sp-values">
          <h2>{t("about.valuesTitle")}</h2>
          <div className="sp-value-items">
            {values.map((val, i) => (
              <div className="sp-value-item" key={i}>
                <div className="sp-value-icon" style={{ background: val.bg, color: val.color }}>
                  <val.icon size={18} />
                </div>
                <div>
                  <h4>{val.title}</h4>
                  <p>{val.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA */}
      <section className="lp-cta">
        <div className="lp-cta-bg" />
        <div className="lp-cta-content">
          <h2>{t("about.ctaTitle")}</h2>
          <p>{t("about.ctaDesc")}</p>
          <Link to="/signup" className="lp-btn lp-btn-white">
            {t("about.ctaButton")}
            <ArrowRight size={18} />
          </Link>
          <div className="lp-cta-bonus">
            <Gift size={16} />
            {t("landing.ctaBonus")}
          </div>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}

export default AboutUs;
